import { pipe, of, forkJoin } from 'rxjs';
import { map, filter, switchMap, take } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { Fetch } from '@app/models/fetch';
import { Location, LocationAppliances } from '@app/models/locations/locations.model';
import { HeaderState, ChangeLocation } from '@app/header/header.state';
import * as i0 from "@angular/core";
import * as i1 from "../fetch";
import * as i2 from "../../header/header.state";
import * as i3 from "@ngxs/store";
var LocationService = /** @class */ (function () {
    function LocationService(fetch, headerState, store) {
        this.fetch = fetch;
        this.headerState = headerState;
        this.store = store;
        this.baseUrl = '/locations';
    }
    LocationService.prototype.getCurrent = function () {
        return this.headerState.getLocation().pipe(take(1));
    };
    LocationService.prototype.get = function (id) {
        return this.fetch.getOne(this.baseUrl, id).model(Location);
    };
    LocationService.prototype.getSome = function (ids) { };
    LocationService.prototype.getAll = function (options) {
        return this.fetch.getAll(this.baseUrl, options).models(Location);
    };
    LocationService.prototype.create = function (loc) {
        return this.fetch.post('/locations', loc);
    };
    LocationService.prototype.update = function (id, loc) {
        var _this = this;
        return this.fetch.patch('/locations', id, loc).pipe(switchMap(function (res) { return _this.headerState.getLocation(); }), switchMap(function (currLoc) {
            if (id === currLoc.id) {
                return _this.get(id).pipe(switchMap(function (newLoc) { return _this.store.dispatch(new ChangeLocation(newLoc)); }));
            }
            return of(currLoc);
        }));
    };
    LocationService.prototype.joinDevice = function (device) {
        return this.get(device.location_id).pipe(map(function (location) {
            device.location = location;
            return device;
        }));
    };
    LocationService.prototype.joinDevices = function (devices) {
        return this.fetch
            .getSome(this.baseUrl, devices.map(function (device) { return device.location_id; }))
            .models(Location)
            .pipe(map(function (locs) {
            for (var i = 0; i < devices.length; i++) {
                devices[i].location = locs[i];
            }
            return devices;
        }));
    };
    LocationService.prototype.joinDevicesPipe = function () {
        var _this = this;
        return pipe(switchMap(function (devices) { return _this.joinDevices(devices); }));
    };
    LocationService.prototype.joinNotificationFromDevice = function (notif) {
        return this.get(notif.device.location_id).pipe(map(function (location) {
            notif.location = location;
            return notif;
        }));
    };
    LocationService.prototype.joinNotificationsFromDevicesPipe = function () {
        var _this = this;
        return pipe(filter(function (notifs) { return !notifs.find(function (notif) { return !notif.device; }); }), switchMap(function (notifs) {
            if (notifs.length === 0) {
                return of(notifs);
            }
            return forkJoin(notifs.map(function (notif) { return _this.joinNotificationFromDevice(notif); }));
        }));
    };
    LocationService.prototype.getUsageProfileAppliances = function () {
        return this.fetch.get('//location-profiles').model(LocationAppliances);
    };
    LocationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LocationService_Factory() { return new LocationService(i0.ɵɵinject(i1.Fetch), i0.ɵɵinject(i2.HeaderState), i0.ɵɵinject(i3.Store)); }, token: LocationService, providedIn: "root" });
    return LocationService;
}());
export { LocationService };
